// lastSeen.mjs — 第一百零七批：管理页账号表「最后活动」列的纯逻辑。
//
// ── 为什么是一个纯模块而不是几行内联 JSX ────────────────────────────────────
// 这一列要回答的是「这个账号最近还在不在用系统」，而**它的边界全是取整**：
// 59 秒是"刚刚"、60 秒是"1 分钟前"、23 小时是"小时"、24 小时是"1 天前"。取整边界
// 写在 JSX 里就只能靠眼睛看，而看错一处的表现是"页面上有个数字，只是不对"——
// 最难被发现的一类错。抽出来 ⇒ 每条边界都能被逐个咬住。
//
// **不在这里调 t()**：返回的是 {key, vars} 描述符，由调用方翻译。理由是这个模块
// 不该知道语言上下文（它连 React 都不 import），而单测也就不必造一个字典桩。
export const MINUTE_MS = 60_000;
export const HOUR_MS   = 3_600_000;
export const DAY_MS    = 86_400_000;

// atMs → {key, vars} | null（null = 从未活动过）。
//
// **从未活动必须与 1970 年分得开**：后端把它投影成 null 而不是 0，这里把 0 / 空
// / 非数字一并折成 null，调用方渲染「—」。一个显示成 "1970-01-01" 的账号看起来
// 像有数据，而它其实是没有数据——那比空白坏得多。
//
// 未来时间戳（时钟偏斜、跨时区的机器）落在"刚刚"这一档：差值为负时第一个分支就
// 命中。**刻意不写成"—1 分钟前"**——一个负数的相对时间只会让人以为页面坏了，
// 而真相（两台机器的钟差了几秒）与这一列要回答的问题毫无关系。
export function relativeSince(atMs, nowMs) {
  const at = Number(atMs);
  if (!atMs || !Number.isFinite(at) || at <= 0) return null;
  const now = Number(nowMs);
  if (!Number.isFinite(now)) return null;
  const d = now - at;
  if (d < MINUTE_MS) return { key: 'time.since.justNow', vars: {} };
  if (d < HOUR_MS)   return { key: 'time.since.minutes', vars: { n: Math.floor(d / MINUTE_MS) } };
  if (d < DAY_MS)    return { key: 'time.since.hours',   vars: { n: Math.floor(d / HOUR_MS) } };
  return { key: 'time.since.days', vars: { n: Math.floor(d / DAY_MS) } };
}

// 凭据类型 → 文案键；认不出来（含空串"从无记录"）返回 ''，调用方据此不显示徽标。
// **认不出的值不猜**：把一个将来新增的 via 值渲染成 "会话" 会让管理页说假话，
// 而少一个徽标只是少一点信息。
export function lastSeenViaKey(via) {
  return via === 'session' || via === 'key' ? `admin.accounts.lastSeen.via.${via}` : '';
}
